import type { MailboxInfo } from 'owa-client-types';
import { action, type ActionCreator } from 'satcheljs';
import type { AsyncItemKind } from 'owa-copilot-async-chat-types';

export interface AsyncItemStartedPayload {
    id: string;
    kind: AsyncItemKind;
    mailboxInfo: MailboxInfo;
}

/** Announces that a new async item has entered its Working lifecycle. */
export const asyncItemStarted: ActionCreator<AsyncItemStartedPayload> = action(
    'asyncItemStarted',
    (payload: AsyncItemStartedPayload) => payload
);
